// extracted by mini-css-extract-plugin
export var cross = "cross-module--cross--+B6qa";
export var horizontal = "cross-module--horizontal--V3JKK";
export var line = "cross-module--line--Kc-5m";
export var lineBox = "cross-module--line-box--fvLuq";
export var opened = "cross-module--opened--HqB9k";
export var vertical = "cross-module--vertical--l46xV";